import { useState } from "react";
// redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
//  api services
import apiParticipantes from "../api/Participantes/api-participantes";
// route
import { useNavigate } from "react-router";
import { initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
import { openNotification } from "../utils/Notifactions";
import { Convocatoria } from "../models/ConvocatoriasModel/convocatoria.model";
import {
  guardarDatosPostulacion,
} from "../redux/actions/participantesAction";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"
import { ObjNotificaciones } from "../config/notificaciones";

export const useAgregarurl = () => {
  // route
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  // redux
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );
  // state
  const [nombrepropuesta, setNombrepropuesta] = useState<string>("");
  const [url, setUrl] = useState<string>("");
  const [urls, setUrls] = useState<Array<any>>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [loading, setLoading] = useState(false);

  const [seltBefore, setSeltBefore] = useState<string>("http://");
  const [seltAfter, setSeltAfter] = useState<string>(".com");

  const handelSelectChacnge = (e: any, tipo: string) => {
    if (tipo == "selectBefore") {
      return setSeltBefore(e);
    } else if (tipo == "selectAfter") {
      return setSeltAfter(e);
    }
  };

  const cambiarnombrepropuesta = (e: any) => {
    return setNombrepropuesta(e.target.value);
  };

  const cambiarurl = (e: any) => {
    return setUrl(e.target.value);
  };

  const agregarurl = () => {
    if (url === "") {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor digite una URL",
        placement: "bottomRight",
      });
    }

    if (/^(ftp|http|https):\/\/[^ "]+$/.test(url)) {
      setUrls([...urls, { index: urls.length, url: `${url}` }]);
      return setUrl("");
    } else {
      return openNotification({
        titulo: "Error",
        descripcion: "No es una estructura de URL valida (Recuerda que debe iniciar en 'https://www')",
        placement: "bottomRight",
      });
    }
  };

  const eliminarurl = (index: number) => {
    let infoupdate = [...urls];
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    return setUrls(infoupdate);
  };

  const [postulacion, setPostulacion] = useState<any>(
    initialValuesPostulacionModel
  );

  const [nombreParticipante, setNombreParticipante] = useState<any>({});

  const getPostulacion = async () => {
    try {
      const id_postulacion = decrypt(localStorage.getItem("id_postulacion"));
      if (!id_postulacion) return;

      const respuesta = await apiParticipantes.consultarPostulacion(id_postulacion);

      // El endpoint devuelve { data: <postulacion> }. La version anterior
      // empezaba por data.data.data.length, que sobre esa forma lanza
      // TypeError: el catch se lo tragaba y ni el nombre ni los enlaces se
      // cargaban nunca al volver a editar. Peor aun, al guardar se mandaba la
      // lista de enlaces vacia y borraba los que ya estaban.
      const cuerpo = respuesta?.data ?? respuesta;
      const postuData: any = Array.isArray(cuerpo) ? cuerpo[0] : cuerpo;

      if (postuData) {
        setNombrepropuesta(postuData.nombre_propuesta || "");
        setUrls(postuData.links || []);
        setPostulacion(postuData);

        if (postuData.primer_nombre) {
          setNombreParticipante(`${postuData.primer_nombre} ${postuData.primer_apellido || ""}`);
        }
      }
      // Se devuelve lo cargado para que quien llame pueda tomarlo como punto
      // de partida y no vuelva a guardar lo que acaba de llegar.
      return postuData;
    } catch (error) {
      console.error("Error al obtener la postulación:", error);
      return null;
    }
  };

  const guardarurl = async () => {
  };

  const postulacionId = 0;
  const crearPostulacion = async (
    convocatorias: Convocatoria,
    userProps: string
  ) => {
    const user = getStorageUser()

    await apiParticipantes.actualizarNombrePropuesta(
      decrypt(localStorage.getItem("id_postulacion")),
      nombrepropuesta
    );
    await apiParticipantes.guardarLinksPostulacion(
      decrypt(localStorage.getItem("id_postulacion")),
      urls
    );

    let nombre_postulado = `${user.nombres} ${user.apellidos}`;
    setNombreParticipante(nombre_postulado);

    const { data: postulacion1 } =
      await apiParticipantes.consultarPostulacionConCreador(
        user.documento,
        decrypt(localStorage.getItem("id_postulacion"))
      );
    localStorage.removeItem("id_postulacion");

    return setPostulacion(postulacion1[0]);
  };

  const continuarurl = async (guardar?: boolean) => {
    console.log("Hola a guardar");

    const id_postulacion = decrypt(localStorage.getItem("id_postulacion"));

    if (nombrepropuesta === "") {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor digite el nombre de la propuesta",
        placement: "bottomRight",
      });
    }
    try {
      setDisableButton(true);
      setLoading(true);
      const user = getStorageUser()
      const { data } = await apiParticipantes.consultarIdParticipante(
        user.documento
      );
      await crearPostulacion(
        datos_postulacion.convocatorias,
        data.id_Participante
      );

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        setOpenModal(true);

        setModal(true);

        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Inscrito sin revisar");

        setLoading(false);
        return;
      }

    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };

  const AceptarModal = () => {
    dispatch(guardarDatosPostulacion({}));
    setModal(false);
    return navigate("/usuario/");
  };

  return {
    nombrepropuesta,
    url,
    setUrl,
    urls,
    setUrls,
    cambiarnombrepropuesta,
    cambiarurl,
    agregarurl,
    eliminarurl,
    guardarurl,
    continuarurl,
    modal,
    AceptarModal,
    setModal,
    getPostulacion,
    postulacion,
    openModal,
    setOpenModal,
    nombreParticipante,
    postulacionId,
    handelSelectChacnge,
    selBefore: seltBefore,
    selAfter: seltAfter,
    disableButton,
    loading,
  };
};
